// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2wjew","footer":"Form_footer__53DrS"};